import React from 'react';
import ProjectContent from '../components/ProjectContent';

const Notapp = () => <ProjectContent projectName='Notapp'/>;

export default Notapp;